import { render, staticRenderFns } from "./Fullscreen.vue?vue&type=template&id=658ebfa6&scoped=true"
import script from "./Fullscreen.vue?vue&type=script&lang=js"
export * from "./Fullscreen.vue?vue&type=script&lang=js"
import style0 from "./Fullscreen.vue?vue&type=style&index=0&id=658ebfa6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658ebfa6",
  null
  
)

export default component.exports